module.exports = __webpack_public_path__ + "img/00012.b003b3af.webp";